module.exports = __webpack_public_path__ + "static/06_bottle_experiments-5601957c1884e5080038ebd86c5f8d39.gif";